import script from "./chevron-right-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./chevron-right-icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__